import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'modifylc_your_flights';
export const route = 'modifylc_your_flights/[[...params]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "modifylc_flightselector" */
/* webpackPrefetch: true */
'../components/FlightSelectorLCPage')));